<form [formGroup]="form" (ngSubmit)="onSave()" (keydown.enter)="$event.preventDefault()">
	<h1 mat-dialog-title class="notification-title no-select">
		{{ 'scim-administration.policyMaps.create.title' | translate }}
	</h1>

	<mat-dialog-content>
		<div class="optional-form-fields">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'scim-administration.policyMaps.create.scimGroup' | translate }}
				</mat-label>
				<mat-select formControlName="groupExternalId" [placeholder]="'scim-administration.policyMaps.create.scimGroupPlaceholder' | translate">
					@for (group of scimGroups; track group.externalId) {
						<mat-option [value]="group.externalId">
							{{ group.displayName }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'scim-administration.policyMaps.create.policy' | translate }}
				</mat-label>
				<mat-select formControlName="policyId" [placeholder]="'scim-administration.policyMaps.create.policyPlaceholder' | translate">
					@for (policy of policies; track policy.id) {
						<mat-option [value]="policy.id">{{ policy.name }} ({{ policy.type }})</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="isLoading || form.invalid">
				{{ 'scim-administration.policyMaps.create.submit' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
				{{ 'scim-administration.policyMaps.create.cancel' | translate }}
			</button>
		</div>
	</div>
</form>
